import { FetchOptionsChainTickers } from "../Apis/FetchOptionsChainTickers";
import { handleApiError } from './notificationActions';
import pako from "pako";


export const FETCH_OPTIONS_CHAIN_TICKERS_FAILURE = 'FETCH_OPTIONS_CHAIN_TICKERS_FAILURE';
export const FETCH_OPTIONS_CHAIN_TICKERS_START = 'FETCH_OPTIONS_CHAIN_TICKERS_START';
export const FETCH_OPTIONS_CHAIN_TICKERS_SUCCESS = 'FETCH_OPTIONS_CHAIN_TICKERS_SUCCESS';

export const fetchOptionsChainTickers = (ticker) => async (dispatch) => {
    return new Promise(async (resolve, reject) => {
        dispatch({ type: FETCH_OPTIONS_CHAIN_TICKERS_START, payload: { ticker } });
        try {
            const today = new Date().toISOString().split('T')[0];
            const response = await FetchOptionsChainTickers(ticker);
            if(response.status === 200){
                const binaryString = atob(response.result);
                const byteArray = Uint8Array.from(binaryString, char => char.charCodeAt(0));
                const decompressed = pako.ungzip(byteArray, { to: "string" });
                const decodedData = JSON.parse(decompressed);
                dispatch({ 
                    type: FETCH_OPTIONS_CHAIN_TICKERS_SUCCESS, 
                    payload: {
                        ticker: ticker,
                        details: decodedData, 
                        fetchedDate: today
                    } 
                });
                resolve(decodedData);
            } else {
                handleApiError(response, dispatch);
                reject(response);
            }
        } catch (error) {
            dispatch({ 
                type: FETCH_OPTIONS_CHAIN_TICKERS_FAILURE, 
                payload: {error: error.toString() } 
            });
            reject(error);
        }
    });
};